export default __webpack_public_path__ + "static/media/Connecticut2Open.bd4accb1.jpg";